import { useTranslation } from 'react-i18next';
import { StatusBadge } from '@/shared/components/StatusBadge';
import type { EstimateStatus } from '../types';

const VARIANTS = {
  draft: 'secondary',
  pending_approval: 'warning',
  approved: 'success',
  presented: 'info',
  converted: 'success',
  lost: 'outline',
  superseded: 'outline',
} as const;

export function EstimateStatusBadge({ status }: { status: EstimateStatus }) {
  const { t } = useTranslation('crm');
  return <StatusBadge status={status} variantMap={VARIANTS} label={t(`estimates.status.${status}`)} />;
}
